import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const AboutSnippet = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <img
              src="/ec83bf83-b176-4f63-868d-9ae37d2cee27.webp"
              alt="Premium transfer vehicle"
              className="w-full h-80 object-cover rounded-lg"
              loading="lazy"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <p className="text-primary font-semibold text-sm uppercase tracking-widest mb-3">
              About Us
            </p>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-foreground mb-6">
              Who We Are
            </h2>
            <p className="text-muted-foreground leading-relaxed mb-4">
              Always On Time Transfers Tours was born from a passion for the Dominican Republic
              and a desire to share its beauty with the world. We provide premium tours and
              reliable transportation across the island.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-6">
              With a fleet of modern vehicles and a team of professional drivers, we ensure
              every journey is comfortable, safe, and — of course — always on time.
            </p>
            <Link to="/about">
              <Button variant="outline" className="gap-2 rounded-lg border-primary text-primary hover:bg-primary hover:text-primary-foreground">
                Learn More <ArrowRight className="w-4 h-4" />
              </Button>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSnippet;
